import { Layout as AntLayout } from 'antd';
import React from 'react';
import { LegalSection } from '@components/Sections/LegalSection/LegalSection';

export const LegalLayout = () => {
  return (
    <AntLayout className="min-h-screen bg-[aliceblue] overflow-x-hidden">
      <AntLayout.Content className="mt-[200px] mb-[30px] px-4 md:px-8 lg:px-16 ">
        <div className="flex justify-center ">
          <LegalSection />
        </div>
      </AntLayout.Content>
    </AntLayout>
  );
};
